import $ from "jquery";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["calculationMethodSelect", "percentUnit", "priceUnit"];
  static values = {
    rate: String,
  };

  connect() {
    let select = this.calculationMethodSelectTarget.selectedOptions[0].value;

    if (select === this.rateValue) {
      this.show(this.percentUnitTarget);
      this.hide(this.priceUnitTarget);
    } else {
      this.show(this.priceUnitTarget);
      this.hide(this.percentUnitTarget);
    }
  }
  change(event) {
    let select = event.target.selectedOptions[0].value;

    if (select === this.rateValue) {
      this.show(this.percentUnitTarget);
      this.hide(this.priceUnitTarget);
    } else {
      this.show(this.priceUnitTarget);
      this.hide(this.percentUnitTarget);
    }
  }

  show(element) {
    $(element).slideDown(10);
  }

  hide(element) {
    $(element).slideUp(10);
  }
}
